/* eslint-disable react/button-has-type */
import styles from "./pabutton.module.scss";

export const BUTTON_DEPTH = {
  NONE: 0,
  MAX: 3,
};

export const BUTTON_SIZE = {
  SMALL: 0,
  MEDIUM: 1,
  LARGE: 2,
  STANDARD: 3,
};

export const BUTTON_TYPE = {
  PRIMARY: 0,
  OUTLINE: 1,
  SECONDRY: 2,
  SECONDRY_OUTLINE: 3,
  NORMAL: 4,
  SUCCESS: 5,
  SUCCESS_OUTLINE: 6,
  NORMAL_OUTLINE: 7,
};

const SIZE_MAPPING = {
  [BUTTON_SIZE.SMALL]: "size_small",
  [BUTTON_SIZE.MEDIUM]: "size_medium",
  [BUTTON_SIZE.LARGE]: "size_large",
};

function PAButton(props: any) {
  const {
    size = BUTTON_SIZE.MEDIUM, buttonType = BUTTON_TYPE.PRIMARY,
    children, depth, zindex, fullWidth, type,
    bold, className = "", widthAuto, style, buttonRef, ...restProps
  } = props;

  const buttonClass = getButtonClass(buttonType);

  function getButtonClass() {
    const commonStyles = `${size === BUTTON_SIZE.STANDARD ? styles.full_height : styles[`${SIZE_MAPPING[size]}`]}
      ${size === BUTTON_SIZE.LARGE ? styles.common_large : styles.common_not_large} 
      ${widthAuto ? styles.width_auto : ""} ${fullWidth ? styles.full_width : ""} 
      ${bold ? styles.bold : ""}`;

    const boxShadowDepth = `${depth === BUTTON_DEPTH.MAX ? styles.box_shadow : ""}`;
    const boxShadowZindex = `${zindex === BUTTON_DEPTH.MAX ? styles.box_shadow : ""}`;

    switch (buttonType) {
    case BUTTON_TYPE.PRIMARY:
      return `primary-button ${styles.primary_button} ${commonStyles} ${boxShadowDepth}`;
    case BUTTON_TYPE.SECONDRY:
      return `secondary-button ${styles.secondary_button} ${commonStyles} ${boxShadowDepth}`;
    case BUTTON_TYPE.OUTLINE:
      return `outline-button ${styles.outline_button} ${commonStyles} ${boxShadowZindex}`;
    case BUTTON_TYPE.SECONDRY_OUTLINE:
      return `secondary-outline-button ${styles.outline_button} ${styles.secondary_outline_button} ${commonStyles} ${boxShadowZindex}`;
    case BUTTON_TYPE.NORMAL:
      return `normal-button ${styles.normal_button} ${fullWidth ? styles.full_width : styles.unset_width}
      ${bold ? styles.bold : styles.normal_font_weight}
      ${size === BUTTON_SIZE.STANDARD ? styles.height_auto : styles[`${SIZE_MAPPING[size]}`]}
      ${size === BUTTON_SIZE.LARGE ? styles.font_size_sm : styles.font_size_xs}`;
    case BUTTON_TYPE.SUCCESS:
      return `success-button ${styles.success_button} ${commonStyles} ${boxShadowZindex}`;
    case BUTTON_TYPE.SUCCESS_OUTLINE:
      return `success-outline-button ${styles.success_outline_button} ${commonStyles} ${boxShadowZindex}`;
    case BUTTON_TYPE.NORMAL_OUTLINE:
      return `${styles.normal_outline_button} ${commonStyles} ${boxShadowZindex}`;
    default:
      return "";
    }
  }

  return (
    <>
      <button
        type={type || "button"}
        className={`${className} ${buttonClass} 
        ${styles.pa_button}`}
        style={{
          ...style,
        }}
        ref={buttonRef || null}
        {...restProps}
      >
        {children}
      </button>
    </>
  );
}

export default PAButton;
